const archiveListingAjax = {
  offset: 0,
  postsPerPage: 2,
  submitButton: null,
  container: null,
  loader: null,
  termId: null,
  taxonomy: null,
  authorId: null,
  isLoading: false,

  init() {
    // Use localized posts_per_page or count actual post elements
    this.postsPerPage = ajax.posts_per_page || document.querySelectorAll('.archive-listing__posts > .article').length || 9;
    this.container = document.querySelector('.archive-listing__posts');
    this.loader = document.querySelector('.loader-container');
    this.submitButton = document.querySelector('.archive-listing__load-more');

    // Initialize offset to the current number of posts shown
    this.offset = document.querySelectorAll('.archive-listing__posts > .article').length;

    // Get term and taxonomy or author from localized script
    this.termId = ajax.term_id || null;
    this.taxonomy = ajax.taxonomy || null;
    this.authorId = ajax.author_id || null;

    this.submitButton?.addEventListener('click', () => this.submit());
  },

  submit() {
    // Prevent multiple concurrent requests
    if (this.isLoading) return;

    this.isLoading = true;
    this.submitButton.disabled = true;

    const data = new FormData();
    data.append('action', ajax.action_name);
    data.append('offset', this.offset);
    data.append('posts_per_page', this.postsPerPage);

    if (this.authorId) {
      data.append('author_id', this.authorId);
    } else {
      data.append('term_id', this.termId);
      data.append('taxonomy', this.taxonomy);
    }

    data.append('nonce', ajax.nonce);

    this.loader.classList.add('active');

    fetch(ajax.ajax_url, {
      method: 'POST',
      body: data,
    })
      .then((res) => res.json())
      .then((data) => {
        const response = data.data;
        const { html, hasMore } = response;

        this.container.insertAdjacentHTML('beforeend', html);

        // Update offset to reflect new post count
        this.offset = document.querySelectorAll('.archive-listing__posts > .article').length;

        if (!hasMore) {
          this.submitButton.classList.add('archive-listing__load-more--hidden');
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.loader.classList.remove('active');
        this.isLoading = false;
        this.submitButton.disabled = false;
      });
  },
};

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.archive-listing')) {
    archiveListingAjax.init();
  }
});
